// Component PaddingInput
import styles from './PaddingInput.module.css'

function PaddingInput({ name, value, onChange }) {
  // Utilisez un input de type number pour le margin
  return <input type="number" name={name} value={value} onChange={onChange} />
}

export default PaddingInput
